import { render } from "./MetatagsListing.vue?vue&type=template&id=356fb94a&ts=true"
import script from "./MetatagsListing.vue?vue&type=script&lang=ts"
export * from "./MetatagsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__